export default __webpack_public_path__ + "static/icon3-ff64aee4b1589de1b9e699121b685955.svg";